module.exports = __webpack_public_path__ + "static/css@2x-aa97de07aab75b912908563e0c1ae8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/css@2x.png
// module id = 2680
// module chunks = 157636680307020